import { useEffect } from 'react';
import PageShell from '../components/layout/PageShell';
import FormCard   from '../components/layout/FormCard';
import { debugLog } from '../utils/logger';

/**
 * ConfirmationPage  (/done)
 * Thank you screen shown after successful preferences submission.
 * Session has been cleared — no further API calls.
 */
export default function ConfirmationPage() {
    useEffect(() => {
        debugLog('ui_confirmation_page_mounted');
    }, []);

    return (
        <PageShell practiceName={null}>
            <FormCard className="text-center py-8">
                {/* Success icon */}
                <div
                    className="flex items-center justify-center mx-auto mb-5 rounded-full"
                    style={{ width: 64, height: 64, background: '#EBF8F3', border: '2px solid #2ECC8E' }}
                    aria-hidden="true"
                >
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#2ECC8E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                </div>

                <h1 className="text-xl font-bold mb-2" style={{ color: '#1B2F7E' }}>
                    Thank you!
                </h1>
                <p className="text-sm leading-relaxed mb-6" style={{ color: '#4a6882' }}>
                    Your communication preferences have been saved. This information will be used to contact you for service and support.
                </p>

                <div
                    className="flex items-start gap-2.5 rounded-lg px-3 py-2.5 text-xs text-left leading-relaxed"
                    style={{ background: '#EAF4FB', border: '0.5px solid #c5dff0', color: '#4a6882' }}
                >
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#2ECC8E" strokeWidth="2" style={{ flexShrink: 0, marginTop: 1 }} aria-hidden="true">
                        <circle cx="12" cy="12" r="10" /><path d="M12 8v4m0 4h.01" />
                    </svg>
                    <p className="m-0">
                        If you need to update your preferences in the future, please contact OPOS support team at{' '}
                        <a href="tel:+16506919500" style={{ color: '#1B2F7E', fontWeight: 600, textDecoration: 'underline', whiteSpace: 'nowrap' }}>
                            (650) 694-9500
                        </a>{' '}
                    </p>
                </div>
            </FormCard>
        </PageShell>
    );
}
